import containerFuild from '../html-snippets/container-fuild';
import cssSnippet from '../css-snippets/section-card-timeline-yuri';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-show="true" data-attribute="title-card" class="card-title">
      <h2 style="text-align:center;">Your Overnight Glow <span style="color:#cb6387!important;">Journey</span>
      </h2>
      <p style="text-align:center;">This is what happens when you use Yuri™ Collagen Night Wrapping Mask consistently.
      </p>
      <p style="text-align:center;">&nbsp;</p>
    </div>
    <div data-show="true" data-attribute="list-item" class="list-item" data-color-highlight="#cb6387"
      style="--color-highlight: #cb6387;">
      <div data-attribute="item-timeline" class="wrap-item-timeline">
        <div class="goup-item-content">
          <div data-attribute="timeline-node" class="timeline-node">First Night</div>
          <div data-attribute="timeline-content" class="timeline-content">
            <h3>Instant Comfort</h3>
            <p><span style="background-color:#ffffff;color:#121212;">Wake up to refreshed, hydrated, and
                noticeably smoother skin after just one use.</span></p>
          </div>
        </div>
      </div>

      <div data-attribute="item-timeline" class="wrap-item-timeline">
        <div class="goup-item-content">
          <div data-attribute="timeline-node" class="timeline-node">Week 1</div>
          <div data-attribute="timeline-content" class="timeline-content">
            <h3>Visible Radiance</h3>
            <p>Elasticity improves, skin feels firmer, and your natural glow becomes more luminous.</p>
          </div>
        </div>
      </div>

      <div data-attribute="item-timeline" class="wrap-item-timeline">
        <div class="goup-item-content">
          <div data-attribute="timeline-node" class="timeline-node">Week 2</div>
          <div data-attribute="timeline-content" class="timeline-content">
            <h3>Restored Balance</h3>
            <p>Fine lines appear softer, moisture stays locked in, and texture looks more refined and even.</p>
          </div>
        </div>
      </div>

      <div data-attribute="item-timeline" class="wrap-item-timeline">
        <div class="goup-item-content">
          <div data-attribute="timeline-node" class="timeline-node">Beyond</div>
          <div data-attribute="timeline-content" class="timeline-content">
            <h3>Ongoing Renewal</h3>
            <p>With nightly use, your skin maintains hydration, firmness, and brightness — so every morning feels like a
              reset.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, cssSnippet, {
  backgroundColor: '#ffffff',
  textColor: '#000000',
});
